<template>
    <div class="agreement-container">
        <div class="agreement">
            <h2>模擬試験に関する規約</h2>
            <ul>
                <li>次の事項に該当する行為を行った場合には、これを不正とみなし、受験の資格を与えません。<br/>
                    また、受験後に不正が発覚した場合には、これを無効とします。<br/>
                    ① 受験申込時に入力された情報に虚偽の記載があった場合<br/>
                    ② 模擬試験問題を他者に口外および公表したことが発覚した場合<br/>
                    ③ 転売サイトでの転売行為が発覚した場合<br/>
                    ④ 住所間違いや不在により、模擬試験書類が当協会に返却された場合、再発送手数料を頂戴いたしますのでご注意ください。<br/>
                    ⑤ 受験申し込み後のキャンセルは一切お受けいたしません。<br/>
                    ⑥ 定員に達し次第、申し込みを終了させていただきます。
                </li>
            </ul>
        </div>
        <div class="agreement-group">
            <div class="check flex flex-row justify-center">
                <FormInput :checked="value"
                           type="checkbox" name="agreement" id="agreement"
                           :true-value="1" :false-value="0"
                           @input="s => $emit('input', s)"/>
                <label for="agreement">規約を読んで同意しました</label>
            </div>
            <ErrorText name="agreement" :errors="errors"/>
        </div>
    </div>
</template>

<script>
import FormInput from "./FormInput";
import ErrorText from "../ErrorText";

export default {
    name: "Agreement",
    components: {ErrorText, FormInput},

    props: {
        value: {
            type: Boolean | Number,
        },
        errors: {
            type: Object | Array,
            required: true
        }
    }
}
</script>

<style scoped>

</style>
